import { Languages, SupportedLanguages } from '@space-shell/constant/languages'
import type { i18n } from 'i18next'

class LanguageUtils {
  static normalizeLocale(locale: string) {
    const amountOfCharactersToSplitLocale = 2

    const currentLocale = locale?.replace('_', '-')
    const language = currentLocale?.slice(0, amountOfCharactersToSplitLocale).toLowerCase()
    const area = currentLocale?.slice(amountOfCharactersToSplitLocale).toUpperCase()

    return `${language}${area}`
  }

  static fallbackUnsupportedLocale(locale: string) {
    const ptRegex = new RegExp('^(pt-[^b].|pt)$')
    const esRegex = new RegExp('^(es-[^b].)$')

    if (ptRegex.test(locale)) {
      return Languages.PtBr
    }

    if (esRegex.test(locale)) {
      return Languages.Es
    }

    return Languages.En
  }

  static formatLocale(locale: string) {
    const supportedLanguages = Object.values(SupportedLanguages)
    const normalizedLocale = this.normalizeLocale(locale)
    const isSupportedLanguage = supportedLanguages.includes(normalizedLocale as SupportedLanguages)
    const formattedLanguage = isSupportedLanguage
      ? normalizedLocale
      : this.fallbackUnsupportedLocale(normalizedLocale)

    return formattedLanguage
  }

  static async setLanguage(locale: string, i18n: i18n) {
    try {
      const resource = await import(`@space-shell/core/locales/${locale}.json`)

      i18n.addResourceBundle(locale, 'translation', resource)
      i18n.changeLanguage(locale)
    } catch {
      i18n.changeLanguage(Languages.En)
    }
  }
}

export default LanguageUtils
